<nb-list>
    <nb-list-item *ngFor="let viewField of viewFields">
        <div class="viewField">
            <span class="label">{{viewField?.title}}</span>
            <span>{{viewField?.value}}</span>
        </div>
    </nb-list-item>
</nb-list>
